import { useState, useEffect } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';

interface AuthState {
  user: firebase.User | null;
  loading: boolean;
}

export const useAuthState = (): AuthState => {
  const [user, setUser] = useState<firebase.User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { user, loading };
};
